import { Helmet } from 'react-helmet-async';
// @mui
import {
    Card,
    Stack,
    Container,
    Typography,
    TableContainer,
    CardContent,
    Button,
    CircularProgress,
    Box,
    Table,
    TableBody,
    TableCell,
    TableRow,
    TableHead,
    Checkbox, InputLabel, FormControl, Input, InputAdornment,
} from '@mui/material';

import {useNavigate, useParams} from 'react-router-dom';

// components
import Scrollbar from '../components/scrollbar';
// sections
import { StepByStepTable } from "../sections/@dashboard/attestations";
import {GeneralLayout} from "../layouts/GeneralLayout";
import Label from "../components/label";
import TextField from "@mui/material/TextField";
import {useEffect, useState} from "react";
import PageTitle from "../components/PageTitle";
import SearchIcon from "@mui/icons-material/Search";
import {SearchSharp} from "@mui/icons-material";
import copyObject from "../utils/copyObject";
import {useLazyGetGroupsByPatternQuery, useSetGroupFlowMutation} from "../store/group/groupApi";

export default function EditGroupFlowsPage() {
    const {id} = useParams();
    const navigate = useNavigate();
    const [isSaving, setIsSaving] = useState(false);
    const [refresh, setRefresh] = useState(false);
    const [getGroups] = useLazyGetGroupsByPatternQuery();
    const [data, setData] = useState([]);
    const [hasAccess, setHasAccess] = useState(false);
    const [pattern, setPattern] = useState('');
    const [setFlows] = useSetGroupFlowMutation();

    useEffect(() => {
        if (localStorage.getItem('roles').split(',').find((item) => item.toLowerCase() === 'attnewadmin') !== undefined) {
            setHasAccess(true);
        }
    }, [])

    function formatDate(dateObj) {
        return `${dateObj.getFullYear()}-${withZero(dateObj.getMonth() + 1)}-${withZero(dateObj.getDate())}`;
    }

    function toDateString(date){
        if (date === null || date === undefined)
            return '';

        return new Date(date).toLocaleDateString("ru-RU");
    }

    function withZero(num) {
        return num < 10 ? `0${num}` : num;
    }

    async function loadData() {
        await getGroups({data: {
                pattern
            }}).unwrap().then((fulfilled) => {
            if (fulfilled?.success) {
                setData(copyObject(fulfilled.data));
            } else {
                fulfilled.errors.map((item) => {
                    alert(item);
                    return 1;
                });

                setIsSaving(false);
            }
        });
    }

    function applyVisualChanges() {
        setRefresh(!refresh);
    }

    const handleSave = async (item) => {
        setIsSaving(true);

        await setFlows({data: item}).unwrap().then((fulfilled) => {
            if (fulfilled?.success) {
                alert('Сохранено')
            } else {
                fulfilled.errors.map((item) => {
                    alert(item);
                    return 1;
                });
            }

            setIsSaving(false);
        });
    };

    return (
        <GeneralLayout>
            <PageTitle title={`Редактировать потоки`} />

            <Container>
                <Stack direction="column"
                       padding="120px 0px 0px 100px"
                       visibility={hasAccess}
                       spacing={2}>
                    <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
                        <Typography variant="h4" gutterBottom>
                            {data === null || data === undefined ? <CircularProgress /> : <></>}
                            Редактировать потоки
                        </Typography>
                    </Stack>

                    <Card>
                        <CardContent>
                            <Stack direction={'row'} spacing={2}>
                                <FormControl variant="standard" fullWidth>
                                    <InputLabel htmlFor="input-with-icon-adornment">
                                        Поиск групп
                                    </InputLabel>
                                    <Input fullWidth
                                           onChange={(event) => {setPattern(event.target.value)}}
                                           id="input-with-icon-adornment"
                                           startAdornment={
                                               <InputAdornment position="start">
                                                   <SearchSharp />
                                               </InputAdornment>
                                           }
                                    />
                                </FormControl>

                                <Button variant={'outlined'}
                                        disabled={pattern.length === 0}
                                        onClick={() => {loadData()}}>Найти</Button>
                            </Stack>
                        </CardContent>
                    </Card>

                    <Card>
                        <Stack spacing={2}>
                            <TableContainer>
                                <Table size={'small'}>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Группа</TableCell>
                                            <TableCell align={'center'}>Номер потока</TableCell>
                                            <TableCell align={'center'}>Действия</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {data?.sort((l,r) => l.groupName > r.groupName ? 1 : -1).map((item) => {
                                            return <TableRow>
                                                <TableCell><strong>{item.groupName}</strong></TableCell>
                                                <TableCell align={'center'}><TextField type={'number'} size={'small'} value={item.flowNumber} onChange={(event) => {item.flowNumber = parseInt(event.target.value, 10); applyVisualChanges()}}/></TableCell>
                                                <TableCell align={'center'}>
                                                    <Button variant={'contained'}
                                                            size={'small'}
                                                            onClick={() => handleSave(item)}
                                                            disabled={isSaving}>Сохранить</Button>
                                                </TableCell>
                                            </TableRow>
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Stack>
                    </Card>
                </Stack>
            </Container>
        </GeneralLayout>
    );
}
